import React from "react";

import IconeCanal from "@/components/canais/IconeCanal";

// Marketplace ainda sem integração (mesmas logos de Configurações → Sistema →
// Integração). Sem número nenhum de propósito: não existe pedido para somar.
export default function CardEmBreve({ canal }) {
  return (
    <div className="flex items-center gap-3 rounded-2xl border-2 border-dashed border-border bg-muted/20 p-4" data-e2e={`em-breve-${canal.key}`}>
      <div className="w-11 h-11 rounded-xl bg-card border flex items-center justify-center shrink-0">
        <IconeCanal canal={canal} className="w-8 h-8 rounded-md" cinza />
      </div>
      <div className="min-w-0">
        <div className="flex items-center gap-2">
          <span className="font-semibold text-sm truncate">{canal.nome}</span>
          <span className="text-[9px] font-bold uppercase tracking-wider px-1.5 py-0.5 rounded bg-amber-500/15 text-amber-600 dark:text-amber-400 shrink-0">Em breve</span>
        </div>
        <p className="text-[11px] text-muted-foreground leading-snug">As vendas do {canal.nome} vão aparecer aqui quando a integração estiver pronta.</p>
      </div>
    </div>
  );
}
